import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Bubble, LoaderButton, ContinueLabel } from "ctia-ui";
import FormElement from "components/FormElement";
import { submitWizardStep } from "actions/wizard";
import { fetchModelList, clearRequests } from "actions/requests";
import { updateModel, clearModel, fetchModelAndVersions } from "actions/model";
import { getStatusTitle } from "helpers/RequestHelper";
import { sortByFieldname } from "helpers/SortHelper";

class SelectModel extends Component {
  componentDidMount() {
    this.props.fetchModelList();
  }

  componentWillUnmount() {
    this.props.clearRequests();
  }

  validate() {
    const { model } = this.props;
    return model && model.selectedVersion;
  }

  formatRequestList() {
    const unsorted = _.map(this.props.requests.models, req => {
      return {
        title: req.modelnumber,
        value: req.id
      };
    });
    const sorted = sortByFieldname(unsorted, "title");

    sorted.unshift({
      title: "--- Select a Model ---",
      value: 0
    });

    return sorted;
  }

  onModelSelect(event) {
    const modelId = Number(event.target.value);
    const { clearModel, fetchModelAndVersions } = this.props;

    return modelId === 0 ? clearModel() : fetchModelAndVersions(modelId);
  }

  onRowClick(id) {
    // emulate real event
    const event = {
      target: {
        name: "selectedVersion",
        value: id
      }
    };

    this.props.updateModel(event);
  }

  renderRows() {
    const { versions, selectedVersion } = this.props.model;

    return _.map(versions, elem => {
      const tn = elem.formatedtransactionnumber;
      const rowStyle =
        selectedVersion === elem.id ? "alert-warning" : "cursor-pointer";
      return (
        <tr
          key={elem.id}
          onClick={this.onRowClick.bind(this, elem.id)}
          className={rowStyle}
        >
          <td>{tn}</td>
          <td>{elem.hwversion}</td>
          <td>{elem.swversion}</td>
          <td>{getStatusTitle(elem.requeststatusid)}</td>
        </tr>
      );
    });
  }

  render() {
    const { wizard, requests, model, request, submitWizardStep } = this.props;

    if (wizard.step !== 1 || !requests) return null;

    if (requests && _.has(requests, "models") && requests.models === false)
      return (
        <Bubble type="danger">
          There are no devices available. An{" "}
          <Link to="/request/new/initial">initial certification</Link> is needed
          first.
        </Bubble>
      );

    const parentModelId = model && model.info ? model.info.id : 0;
    const noVersions =
      model && model.versions ? model.versions.length === 0 : false;
    const { isLoading } = request;

    return (
      <div>
        <Bubble show={!parentModelId}>Please select a model.</Bubble>
        <Form horizontal>
          <FormElement
            type="select"
            id="parentModelId"
            label="Select Model"
            value={parentModelId}
            onChange={this.onModelSelect.bind(this)}
            options={this.formatRequestList()}
          />
          <Bubble show={parentModelId > 0 && !noVersions}>
            Please select the parent device's HW/SW version.
          </Bubble>
          <Bubble show={noVersions} type="warning">
            Selected model has not been approved yet. Please choose another
            model.
          </Bubble>
          {parentModelId > 0 && !noVersions ? (
            <Table condensed hover>
              <thead>
                <tr>
                  <th>Request Id</th>
                  <th>HW Version</th>
                  <th>SW Version</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>{this.renderRows()}</tbody>
            </Table>
          ) : null}
          <div className="text-right">
            <LoaderButton
              disabled={!this.validate()}
              bsStyle="info"
              text={<ContinueLabel />}
              show={model !== null}
              isLoading={isLoading}
              onClick={() => submitWizardStep(wizard)}
            />
          </div>
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ request, wizard, requests, model, user }) {
  return { request, wizard, requests, model, user };
}

export default connect(mapStateToProps, {
  submitWizardStep,
  fetchModelList,
  updateModel,
  clearModel,
  clearRequests,
  fetchModelAndVersions
})(SelectModel);



// WEBPACK FOOTER //
// ./src/containers/request/ECO/SelectModel.js